// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInCalendarDays as fn } from "../differenceInCalendarDays.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInCalendarDaysWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default differenceInCalendarDaysWithOptions;
